export default __webpack_public_path__ + "static/media/ASR.995bfa3e.png";